<template>
    <AssetsOverview
        :product-id="currentProductSelection"
        :show-jump-to-product="false"
        :emit-selection-in-tiles="!isLastLevel || emitLastLevelSelection"
        :selection-data="selectionData"
        :selection-options="selectionOptions"
        @select="onSelect"
        dense
        :is-search="false"
    />
</template>

<script setup lang="ts">
import {
    QualificationLevelSelectionResult,
    QualificationLevelSelectionOptions,
} from "@/shared/environment/ability.types";
import { computed } from "vue";
import AssetsOverview from "./assets-overview.vue";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases";

const props = defineProps<{
    selectionData: QualificationLevelSelectionResult;
    isLastLevel: boolean;
    selectionOptions?: QualificationLevelSelectionOptions;
    emitLastLevelSelection?: boolean;
}>();

const emit = defineEmits<{
    (e: "select", selectionResult: QualificationLevelSelectionResult): void;
}>();

const currentProductSelection = computed(() => {
    return props.selectionData.product;
});

const onSelect = (productId: string, assetId: string) => {
    const result: QualificationLevelSelectionResult = {
        ...props.selectionData,
        [CommonRouteAliases.asset]: assetId,
        [CommonRouteAliases.product]: productId,
    };
    emit("select", result);
};
</script>

<style lang="scss" scoped>
:deep(.preview-image) {
    height: 100%;
}
</style>
